const NO_SEASON_KEY = '__no_season__'
const NO_SEASON_LABEL = 'No season'

function seasonRecord(event) {
  const season = event?.season
  if (!season || typeof season !== 'object') return null
  if (Array.isArray(season)) return season.find((item) => item) || null
  return season
}

function yearOf(value) {
  if (!value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return date.getFullYear()
}

function formatSeasonYears(season) {
  const startYear = yearOf(season?.start)
  if (!startYear) return ''
  const endYear = yearOf(season?.ends) || startYear + 1
  const startYY = String(startYear).slice(-2)
  const endYY = String(endYear).slice(-2)
  if (startYear === endYear) return `${startYY} Season`
  return `${startYY}/${endYY} Season`
}

function seasonLabel(season) {
  const name = typeof season?.name === 'string' ? season.name.trim() : ''
  if (name) return name
  return formatSeasonYears(season) || NO_SEASON_LABEL
}

function seasonKey(season, label) {
  if (season?.uuid) return String(season.uuid)
  if (season?.id != null) return String(season.id)
  return label
}

function containsNow(group, now) {
  if (!group.start || !group.ends) return false
  const start = new Date(group.start)
  const end = new Date(group.ends)
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false
  return now >= start && now <= end
}

function compareGroups(a, b, now) {
  if (a.key === NO_SEASON_KEY) return 1
  if (b.key === NO_SEASON_KEY) return -1

  const aCurrent = containsNow(a, now)
  const bCurrent = containsNow(b, now)
  if (aCurrent !== bCurrent) return aCurrent ? -1 : 1

  const aStart = a.start ? new Date(a.start).getTime() : NaN
  const bStart = b.start ? new Date(b.start).getTime() : NaN
  const aHasStart = !Number.isNaN(aStart)
  const bHasStart = !Number.isNaN(bStart)
  if (aHasStart && bHasStart && aStart !== bStart) return bStart - aStart
  if (aHasStart !== bHasStart) return aHasStart ? -1 : 1

  return a.label.localeCompare(b.label)
}

export function groupEventsBySeason(events, now = new Date()) {
  const groups = new Map()

  for (const event of events || []) {
    const season = seasonRecord(event)
    const label = season ? seasonLabel(season) : NO_SEASON_LABEL
    const key = season ? seasonKey(season, label) : NO_SEASON_KEY
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        label,
        start: season?.start || null,
        ends: season?.ends || null,
        events: [],
      })
    }
    groups.get(key).events.push(event)
  }

  return [...groups.values()].sort((a, b) => compareGroups(a, b, now))
}
